export const webAnalyticsFeatures = {
    summary: {
        name: 'Web Analytics',
        description: 'Privacy-focused web analytics with real-time data and no sampling',
        url: '/web-analytics',
        docsUrl: '/docs/web-analytics',
    },
    features: {
        bounce_rate: {
            name: 'Bounce rate',
            description: 'See the percentage of users that leave after one pageview',
        },
        conversions: {
            name: 'Conversions',
            description: 'Track actions you want users to take',
        },
        custom_channel_types: {
            name: 'Custom channel types',
            description: 'Create custom channel types by defining rules that match incoming events',
        },
        entry_exit_paths: {
            name: 'Entry and exit paths',
            description: 'See the pages users first visit and the last ones before they leave',
        },
        movement_maps: {
            name: 'Movement maps',
            description: 'Visualize mouse movements',
        },
        outbound_clicks: {
            name: 'Outbound clicks',
            description: 'See the links that take users away',
        },
        pageviews: {
            name: 'Pageviews',
            description: 'Track visitors and their views',
        },
        sessions: {
            name: 'Sessions',
            description: 'Track unique sessions and their durations',
        },
        traffic_breakdown: {
            name: 'Traffic breakdown',
            description: 'See where your visitors and conversions are coming from',
        },
        utm_tracking: {
            name: 'UTM tracking',
            description: 'Track marketing campaigns with UTM tags',
        },
        web_vitals: {
            name: 'Web vitals',
            description: 'Monitor the performance of your website',
        },
        cookieless_tracking: {
            name: 'Cookieless tracking',
            description: 'Track users without cookies',
        },
        snippet_install: {
            name: 'Snippet install',
            description: 'Install HTML snippet',
        },
        search_tools: {
            name: 'Search tools',
            description: 'Get keyword data and track search ad performance',
        },
        migration: {
            name: 'Migration from Google Analytics',
            description: 'Migrate data from Google Analytics',
        },
        script_size: {
            name: 'Script size',
            description: 'Size of the script that runs on your site',
        },
    },
}
